import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { finalize, map, Observable } from 'rxjs';

import { Customer } from '@shared/models';

import { BaseService } from '../base.service';
import { LoadersService } from '../loaders.service';

@Injectable({
  providedIn: 'root',
})
export class CustomersService extends BaseService {
  constructor(
    private http: HttpClient,
    private loadersService: LoadersService
  ) {
    super();
  }

  getAll(loader: string): Observable<Customer[]> {
    this.loadersService.show(loader);

    const url = `${this.baseUrl}/customers`;
    return this.http.get<Customer[]>(url).pipe(finalize(() => this.loadersService.hide(loader)));
  }

  add(loader: string, dto: Customer): Observable<Customer> {
    this.loadersService.show(loader);
    return this.http
      .post<Customer>(this.baseUrl + '/customers', dto)
      .pipe(finalize(() => this.loadersService.hide(loader)));
  }

  edit(loader: string, dto: Customer): Observable<Customer> {
    this.loadersService.show(loader);
    return this.http
      .put<Customer>(this.baseUrl + '/customers', dto)
      .pipe(finalize(() => this.loadersService.hide(loader)));
  }

  delete(loader: string, id: string): Observable<boolean> {
    this.loadersService.show(loader);
    return this.http.delete(`${this.baseUrl}/customers/${id}`, { observe: 'response' }).pipe(
      map((response) => this.isStatusSucceed(response.status)),
      finalize(() => this.loadersService.hide(loader))
    );
  }
}
